import { Toast } from 'primereact/toast';
import React, { createContext, useContext, useRef } from "react";
import { useTranslation } from 'react-i18next';

let operationsAllowed: any = {};
const ToasterServiceContext = createContext(operationsAllowed);

export const ToasterServiceProvider = (props: any) => {
  const toast: any = useRef(null);
  const { t } = useTranslation();
  
  const showError = (message: string) => {
    toast.current.show({severity: "error", summary: t("generic.label.error"), detail: message});  
  }

  const showWarning = (message: string) => {
    toast.current.show({severity: "warn", summary: t("generic.label.warning"), detail: message});  
  }

  const showInfo = (message: string) => {
    toast.current.show({severity: "info", summary: t("generic.label.info"), detail: message});  
  }

  const showSuccess = (message: string) => {
    toast.current.show({severity: "success", summary: t("generic.label.success"), detail: message});  
  }

  operationsAllowed = {
    showError,
    showWarning,
    showInfo,
    showSuccess
  };

  return (
    <ToasterServiceContext.Provider value={operationsAllowed}>
      <Toast ref={toast} baseZIndex={99999999}/>
      {props.children}
    </ToasterServiceContext.Provider>
  )
}

export const useToasterService = () => {
  return useContext(ToasterServiceContext);
}